export default __webpack_public_path__ + "static/media/icono-seguimiento.fe3d9f77.jpg";